import React from "react"
import { Paper, Toggle } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IWorkPoolEmployee } from "../../../models"
import ShiftWorkPoolEmployeeTable from "./ShiftWorkPoolEmployeeTable"
interface IProps {
    readonly?: boolean
    submittedCandidates: IWorkPoolEmployee[]
    shortListCandidate(employeeId: string): void
    assignEmployeeToShift:(employee:IWorkPoolEmployee) => void
    
}
interface IState {
    submittedCandidates: IWorkPoolEmployee[]
    offset: number
    limit: number
    expanded: boolean
    showArchived: boolean
}

export default class ShiftSubmittedCandidates extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            submittedCandidates: props.submittedCandidates,
            offset: 0,
            limit: 20,
            expanded: false,
            showArchived: true
        }
        autobind(this)
    }

    componentWillReceiveProps (newProps) {
        if (this.props.submittedCandidates !== newProps.submittedCandidates) {
            this.setState({ submittedCandidates: newProps.submittedCandidates })
        }
    }


    render() {
        const viewableEmployees = this.state.submittedCandidates.slice(this.state.offset, Math.min(this.state.offset + this.state.limit, this.state.submittedCandidates.length))
        return (
            <Paper zDepth={1} style={{ marginBottom: 20 }}>
                <div style={{ position: "relative", }}>
                    <div style={{ fontSize: 15, fontWeight: "bold", padding: 25 }}>
                        {strings.Submitted_Candidates}
                    </div>
                   {this.state.expanded &&
                         <div>
                            {this.props.submittedCandidates.length !== 0 &&
                                <Toggle
                                    onToggle={(e, checked) =>
                                        this.setState({ showArchived: checked }, () => {
                                            if (!this.state.showArchived) {
                                                const submittedCandidates = this.state.submittedCandidates.slice().filter(item => item.ArchivedByUserIds.length === 0)
                                                this.setState({ submittedCandidates })
                                            } else {
                                                this.setState({ submittedCandidates: this.props.submittedCandidates })
                                            }
                                        })
                                    }
                                    style={{ width: 200, position: "absolute", right: 60 }}
                                    defaultToggled={this.state.showArchived}
                                    label={strings.Show_Archived}
                                    disabled={this.props.readonly}
                                />
                            }
                            <br></br>
                            <ShiftWorkPoolEmployeeTable
                                tableName={"submitted"}
                                saveColumn
                                submittedByColumn
                                readonly={true}
                                workPoolEmployees={viewableEmployees}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[20, 50, 100]}
                                total={this.state.submittedCandidates.length}
                                onPageClick={offset => this.setState({ offset })}
                                onLimitChange={limit => this.setState({ limit, offset: 0 })}
                                shortListCandidate={this.props.shortListCandidate}
                                assignEmployeeToShift={this.props.assignEmployeeToShift}
                            />
                        </div>
                   }
                    <div style={{ position: "absolute", right: 15, top: 15, fontSize: 18 }}>
                        <i
                            className={"fa " + (this.state.expanded ? "fa-chevron-up" : "fa-chevron-down") + " itemActionButton"}
                            onClick={() => this.setState({ expanded: !this.state.expanded })}
                        />
                    </div>
                </div>
            </Paper>
        )
    }
}